export interface CourseStub {
  title: string;
  description: string;
  slug: string;
}

export interface SchoolLandingResponse {
  title: string;
  tagline: string;
  courses: CourseStub[];
}

export interface UserOut {
  id: number;
  email: string;
  display_name: string | null;
  email_verified: boolean;
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(path, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...init.headers,
    },
    ...init,
  });
  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }
  return response.json() as Promise<T>;
}

export const api = {
  getLanding: (): Promise<SchoolLandingResponse> =>
    request('/api/school/landing'),
  getMe: (): Promise<UserOut> => request('/auth/me'),
  // register() and login() were REMOVED (2026-08-09): this app has no local
  // password login. Sign-in is a top-level navigation to /auth/login, which the
  // backend 302s to auth.mellott.us — see src/app/login/page.tsx for why it
  // cannot be an XHR.
  logout: (): Promise<{ status: string }> =>
    request('/auth/logout', { method: 'POST' }),
};
